import { useQuery } from '@tanstack/react-query';
import { IBaseUseQueryProps } from '../../../interfaces/baseUseQueryProps';
import { IProjectApplicant } from '../../../interfaces/projectApplicant';
import { parseAxiosError } from '../../../services/axios';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../interfaces/errorResponse';
import { useNotification } from '../../../+state/useNotification';

export const GET_POSITION_APPLICANTS_QUERY_KEY = 'get-position-applicants';

interface IProps extends IBaseUseQueryProps<IProjectApplicant[]> {
  handler: () => Promise<IProjectApplicant[]>,
  dependency: string
}

export const useGetPositionApplicants = ({ handler, dependency, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_POSITION_APPLICANTS_QUERY_KEY, dependency],
    queryFn: handler,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      props?.onError?.(err);
    },
    refetchOnWindowFocus: false,
    retry: 0,
    ...props
  });
};